import { useGetGamesQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * Fetches every tracked game in the current network/month scope, intentionally
 * ignoring the dashboard's `genreFilter`. The dashboard's "Games Tracked"
 * summary card uses the genre-scoped count, but the dialog needs the full set
 * so the user can re-pick a different genre (or "All Genres") in-place without
 * having to first close the dialog and clear the dashboard filter.
 */
export const useAllGamesListing = (enabled = true) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetGamesQuery({ networkId: networkId ?? undefined, month: month ?? undefined }, { skip: !enabled })
  return { data: data ? { games: data.games } : undefined, isLoading: isFetching, isError, refetch }
}
